import { UIActionType, UIAction } from '../../actions/uiActions';

const selectedActivityRunIdReducer = (state = '', action: UIAction) => {
  if (action.type === UIActionType.SET_SELECTED_ACTIVITY_RUN_ID) return action.id;
  return state;
};

export default selectedActivityRunIdReducer;
